export interface ConfigurationSiteTenant {
    attribute: string;
    description: string;
    sitetenantfield: string;
    type: string;
    values: string;
    _id: string;
}
